'use client';

import classnames from 'classnames';

import { useSanitizedHtml } from '../../../../utils/sanitize';
import { Loading } from '../../../loading';
import { TagList } from '../../layout/TagList';

import styles from './AnswerExplanation.module.scss';

type AnswerExplanationProps = {
  title: string;
  variant: 'reason' | 'explanation';
  /** Sanitized and rendered as HTML. Nothing yet means it is still being written. */
  html?: string;
  tags?: string[];
};

/**
 * Prose about the answer — the question's own justification, or the analysis written for
 * the attempt. Prose still on its way shows a spinner rather than an empty panel.
 */
function AnswerExplanation({
  title,
  variant,
  html,
  tags,
}: AnswerExplanationProps) {
  const contentHtml = useSanitizedHtml(html ?? '');

  return (
    <div className={styles['explanation']}>
      <span
        className={classnames(styles['title'], styles[`title--${variant}`])}
      >
        {title}
      </span>
      {html ? (
        <div className={styles['text']} dangerouslySetInnerHTML={contentHtml} />
      ) : (
        <div className={styles['loading']}>
          <Loading />
        </div>
      )}
      <TagList tags={tags} />
    </div>
  );
}

export { AnswerExplanation };
